import VideoViewerSmallViewPort from "./VideoViewerSmallViewPort";

export default VideoViewerSmallViewPort;
